(ns app.domain.counter-config.model
  (:require [potpuri.core :as p]))

(def counter-config-types #{:counter-config.type/escrow-account
                            :counter-config.type/deficiency
                            :counter-config.type/inspection-photo
                            :counter-config.type/bill-invoice-number})

(def modifiable-attributes
  [:counter-config/template
   :counter-config/prefix
   :counter-config/initial-counter
   :counter-config/separator
   :counter-config/digits])

(defn initial-counter-editable? [config-type]
  (-> config-type
      #{:counter-config.type/deficiency :counter-config.type/inspection-photo}
      not))

(defn template-prefix-mandatory? [{:counter-config/keys [type]}]
  (#{:counter-config.type/deficiency :counter-config.type/inspection-photo} type))

(defn- optional-attribute-error?
  "When template contains attribute character but there is no valid attribute"
  [{:counter-config/keys [template] :as config} attr reg-ex]
  (let [attr-char-in-template? (re-find reg-ex template)
        attribute-value        (attr config)]
    (and attr-char-in-template?
         (or (nil? attribute-value)
             (= "" attribute-value)))))

(defn template-has-year? [template]
  (boolean (re-find #"Y" template)))

(defn validation-errors
  "Returns vector of validation errors.
  Single validation error is [tr-key tr-args], which corresponds to a valid (tr [tr-key] tr-args)."
  [{:counter-config/keys [template initial-counter digits]
    :keys                [min-value]                       :as config}]
  (let [min-value (or min-value 0)]
    (if (and template
             (not= "" template))
      (let [year-next-to-number? (or (re-find #"YYN|YYYYN" template)
                                     (re-find #"NYY|NYYYY" template))
            y-count              (count (re-seq #"Y" template))]
        (cond-> []
          (nil? (re-matches #"^[PSYNC]+$" template))
          (conj [:counter-config.error/template-contains-invalid-characters])

          (not (re-find #".*N.*" template))
          (conj [:counter-config.error/template-must-include-number])

          (optional-attribute-error? config :counter-config/prefix #".*P.*")
          (conj [:counter-config.error/prefix-in-template-with-invalid-attribute])

          (optional-attribute-error? config :counter-config/separator #".*S.*")
          (conj [:counter-config.error/separator-in-template-with-invalid-attribute])

          (and (template-has-year? template)
               (not= 2 y-count)
               (not= 4 y-count))
          (conj [:counter-config.error/invalid-year-in-template])

          (and (template-has-year? template)
               year-next-to-number?)
          (conj [:counter-config.error/no-separator-between-year-and-number])

          (and digits (> digits 10))
          (conj [:counter-config.error/too-many-digits])

          (and initial-counter min-value (< initial-counter min-value))
          (conj [:counter-config.error/initial-counter-must-be-at-least [(inc min-value)]])

          (and (template-prefix-mandatory? config) (not (re-find #".*P.*" template)))
          (conj [:counter-config.error/template-must-include-prefix])))
      [[:counter-config.error/template-must-include-number]])))

(defn validation-error-texts
  "Helper function that returns vector of error strings given a tr function."
  [tr config]
  (->> config
       validation-errors
       (mapv (fn [[tr-key tr-args]]
               (tr [tr-key] tr-args)))))

(defn group-counter-config-of-type [group type]
  (-> group
      :counter-config/_parent
      (p/find-first {:counter-config/type type})))
